export enum EquipmentsMutations {
    SET_EQUIPMENTS = 'SET_EQUIPMENTS',
    SET_DATACENTERS = 'SET_DATACENTERS',
    SET_PARAMETERS = 'SET_PARAMETERS',
}
